import { render, staticRenderFns } from "./driver.vue?vue&type=template&id=cf584d6c&scoped=true&"
import script from "./driver.vue?vue&type=script&lang=js&"
export * from "./driver.vue?vue&type=script&lang=js&"
import style0 from "./driver.vue?vue&type=style&index=0&id=cf584d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf584d6c",
  null
  
)

export default component.exports